class StatusSolicitacaoMovimentacaoIBPEnum {

    constructor(descricao, value) {
        this.descricao = descricao;
        this.value = value;
    }

    static fromValue(value) {
        return Object.values(StatusSolicitacaoMovimentacaoIBPEnum).find(status => status.value === value);
    }

    static fromDescricao(descricao) {
        return Object.values(StatusSolicitacaoMovimentacaoIBPEnum).find(status => status.descricao === descricao);
    }
}


StatusSolicitacaoMovimentacaoIBPEnum.EM_DIGITACAO = new StatusSolicitacaoMovimentacaoIBPEnum("Em digitação", 48);
StatusSolicitacaoMovimentacaoIBPEnum.EM_ANDAMENTO = new StatusSolicitacaoMovimentacaoIBPEnum("Em andamento", 51);
StatusSolicitacaoMovimentacaoIBPEnum.FINALIZADO = new StatusSolicitacaoMovimentacaoIBPEnum("Finalizado", 57);
StatusSolicitacaoMovimentacaoIBPEnum.CONCLUIDO_ADM = new StatusSolicitacaoMovimentacaoIBPEnum("Concluido ADM", 250);


export default StatusSolicitacaoMovimentacaoIBPEnum;